
import { TeacherSchedule } from "@/components/teacher/schedule/TeacherSchedule";

export default function TeacherSchedulePage() {
  return (
    <TeacherSchedule />
  );
}
